import React from "react";

import { Button, Typography, makeStyles } from "@material-ui/core";

const determineColorOnType = (type) => {
  const data = {
    cancel: "#E2136E",
    ok: "#FFF8FB",
  };

  return data[type];
};

const determineBgColorOnType = (type) => {
  const data = {
    ok: "#E2136E",
    cancel: "#FFF8FB",
  };

  return data[type];
};

const useStyle = (type, width) => {
  return makeStyles((theme) => ({
    typographyStyle: { fontSize: 14, fontWeight: 600 },
    baseButtonStyle: {
      borderRadius: theme.spacing(4),
      textTransform: "none",
      height: 38,
      fontSize: 12,
      backgroundColor: determineBgColorOnType(type),
      color: determineColorOnType(type),
      width: width,
      padding: 1,
      "&:hover": {
        backgroundColor: "#fff",
        color: "#3c52b2",
      },
    },
  }));
};

export default function CustomButton({ width, text, type, typeOf, ...rest }) {
  const style = useStyle(type, width)();

  return (
    <Button
      variant="contained"
      className={style.baseButtonStyle}
      type={typeOf}
      {...rest}
    >
      <Typography variant="subtitle1" className={style.typographyStyle}>
        {text}
      </Typography>
    </Button>
  );
}

CustomButton.defaultProps = {
  width: "100%",
};
